import type { Contract } from "@/views/contract/contract";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: Contract) {
  entity._authRequestFields = ["id", "statusMurn"];
  return entity;
}
function getInitialData() {
  const result = {} as Contract; //TODO: ts
  return addAuthRequestFields(result);
}
async function skinnyResponseAdapter(response: { data: Contract }) {
  addAuthRequestFields(response.data);
  return response.data;
}
async function responseAdapter(response: { data: Contract }) {
  return await skinnyResponseAdapter(response);
}
function requestAdapter(data: Contract) {
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Contract) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Contract) {}
